import React from 'react';
import { cn } from '../../../lib/utils';

/**
 * Cabecera de sección con estilo FancyYool
 * Título grande y subtítulo inline o en bloque.
 */
const SectionHeader = ({
  title,
  subtitle,
  action,
  className,
  titleClassName,
  subtitleClassName,
  align = 'left' // 'left', 'center', 'right'
}) => {
  return (
    <div 
      className={cn(
        "flex flex-col gap-1 mb-6", 
        align === 'center' && "items-center text-center",
        align === 'right' && "items-end text-right",
        align === 'left' && "items-start text-left",
        className
      )}
    >
      <div className="flex w-full items-center justify-between gap-4">
        <div className="flex flex-col gap-1">
          <h1 className={cn("fancyyool-title tracking-tight", titleClassName)}>
            {title}
          </h1>
          {subtitle && (
            <p className={cn("text-lg text-muted-foreground", subtitleClassName)}>
              {subtitle}
            </p>
          )}
        </div>
        {action && (
          <div className="flex-shrink-0">
            {action}
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
